require('../bootstrap');

import { initialiseCart } from './cart';
import { initialiseHeaderSearch } from './header-search';
import { initialiseStockNotifications } from './stock-notifications';

/*
 * Do not import or start Alpine here.
 * Livewire 3 already provides and starts Alpine.
 */

initialiseHeaderSearch();
initialiseCart();
initialiseStockNotifications();

function initAnnouncement() {
    const announcement = document.querySelector('[data-announcement]');

    if (!announcement) {
        return;
    }

    const key = announcement.dataset.announcementKey;

    if (!key) {
        return;
    }

    const storageKey = `magickast_announcement_dismissed_${key}`;

    try {
        if (localStorage.getItem(storageKey) === '1') {
            announcement.remove();
            return;
        }
    } catch (error) {
        // localStorage may be unavailable, for example in some privacy modes.
        // In that case we simply show the announcement.
    }

    announcement.hidden = false;

    const closeButton = announcement.querySelector(
        '[data-announcement-close]'
    );

    if (!closeButton) {
        return;
    }

    closeButton.addEventListener('click', function () {
        try {
            localStorage.setItem(storageKey, '1');
        } catch (error) {
            // Ignore storage errors. The announcement can still be closed
            // for the current page view.
        }

        announcement.remove();
    });
}

document.addEventListener('DOMContentLoaded', initAnnouncement);